import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/locale/LocaleSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenuBar"] */ "/vercel/path0/src/components/navbar/navigation-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/vercel/path0/src/components/theme/theme-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/src/components/ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sheet","SheetTrigger","SheetContent","SheetHeader","SheetDescription"] */ "/vercel/path0/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextHoverEffect"] */ "/vercel/path0/src/components/ui/text-hover-effect.tsx");
